import { EzNewswireLogo } from 'icons/EzNewswireLogo';
import { Link } from '@/app_components/common/Link';
import { ContentPlacement } from '@/app_lib/types/analytics';

interface InListCtaProps {
  ctaUrl: string;
}

export const InListCta = ({ ctaUrl }: InListCtaProps) => {
  return (
    <div
      className='flex flex-col items-center p-6 lg:p-8 xl:p-10 gap-6 rounded-sm bg-accent-inverse shadow-[0_0_24px_0_rgba(17,17,17,0.04)] font-graphik-compact'
      data-cy={ContentPlacement.EzNewswirePressReleaseListInlineCta}
    >
      <div className='flex flex-col items-center gap-4'>
        <EzNewswireLogo />
        <div className='text-primary text-center typography-default font-normal'>Publish your business news here.</div>
      </div>
      <Link
        className='px-8 py-4 rounded-full button-primary button-primary-hover button-text-primary text-base leading-4 font-medium'
        data-cy={ContentPlacement.EzNewswirePressReleaseListInlineCtaButton}
        href={`${ctaUrl}&utm_content=incontent_link`}
        rel='sponsored'
        target='_blank'
      >
        Get started
      </Link>
    </div>
  );
};
